import { render, staticRenderFns } from "./CustomerTaskTypes.vue?vue&type=template&id=3063a29c"
import script from "./CustomerTaskTypes.vue?vue&type=script&lang=js"
export * from "./CustomerTaskTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports